import { 
  ACTION, RequestSearchExternalProvider, ReceiveSearchExternalProvider, 
  FailSearchExternalProvider } from './action-types';
import { ActionMap } from 'app/area/case/types';
import { CaseState } from 'app/area/case/types-store';

export const reducers: ActionMap = {
  [ACTION.REQUEST_SEARCH_EXTERNAL_PROVIDER]: (state: CaseState, action: RequestSearchExternalProvider): CaseState => ({
    ...state,
    searchExternalProvider: {
      fetching: true,
      caseDraftId: action.caseDraftId,
      domainId: action.domainId,
      searchConditions: action.searchConditions,
      resultItems: undefined,
      error: undefined
    }
  }),
  [ACTION.RECEIVE_SEARCH_EXTERNAL_PROVIDER]: (state: CaseState, action: ReceiveSearchExternalProvider): CaseState => ({
    ...state,
    searchExternalProvider: {
      ...(state.searchExternalProvider || {}),
      fetching: false,
      caseDraftId: action.caseDraftId,
      domainId: action.domainId,
      searchConditions: undefined,
      resultItems: action.resultItems,
      error: undefined
    }
  }),
  [ACTION.FAIL_SEARCH_EXTERNAL_PROVIDER]: (state: CaseState, action: FailSearchExternalProvider): CaseState => ({
    ...state,
    searchExternalProvider: {
      fetching: false,
      caseDraftId: action.caseDraftId,
      domainId: action.domainId,
      error: action.error
    }
  }),
  [ACTION.CLEAR_SEARCH_EXTERNAL_PROVIDER_RESULTS]: (state: CaseState): CaseState => ({
    ...state,
    searchExternalProvider: undefined
  })
};
